export default __webpack_public_path__ + "static/media/default_marker.afe7e22c.png";